<template>
  <section
    class="customer-reviews"
    :style="{ backgroundColor: backgroundColor }"
  >
    <div
      class="customer-reviews__title"
      :style="{ fontSize: titleFontSize, lineHeight: titleLineHeight }"
    >
      {{ sectionTitle ? sectionTitle : $t("paywall.customerReviewsTitle") }}
    </div>
    <div class="review-wrapper">
      <div
        v-for="(slide, i) in reviews"
        :key="`Review_${i}`"
        class="customer-reviews__content"
        :class="showShadow && 'shadow'"
      >
        <div class="card">
          <div class="header">
            <div class="portrait">
              <div class="portrait__icon">
                <img :src="`${mediaBaseUrl}${slide.image}`" />
              </div>
              <div class="portrait__text">{{ slide.name }}</div>
            </div>
            <div class="stars">
              <img
                v-for="star in slide.stars"
                :key="`Swiper-Slide-Star_${star}`"
                :src="`${mediaBaseUrl}paywall/star.svg`"
                class="stars__icon"
              />
            </div>
          </div>
          <div class="content">
            <div class="content__text">{{ slide.text }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  inject: ["mediaBaseUrl"],
  props: {
    reviews: {
      type: Array,
      default: [],
    },
    sectionTitle: {
      type: String,
      required: false
    },
    backgroundColor: {
      type: String,
      default: "#FFFFFF",
    },
    titleFontSize: {
      type: String,
      default: "24px",
    },
    titleLineHeight: {
      type: String,
      default: "33.6px",
    },
    showShadow: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style scoped lang="sass">
$lg: 700px

.customer-reviews
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  background: #FFFFFF
  gap: 16px
  padding: 48px 16px 80px !important

  &__title
    font-size: 24px
    font-weight: 700
    line-height: 33.6px
    text-align: center
    color: #1B2A3F
    margin-bottom: 11px

  &__content
    display: flex
    flex-direction: column
    gap: 16px
    justify-content: center
    align-items: center
    max-width: 343px
    border-radius: 16px

    &.shadow
      box-shadow: 1px 3px 8px 0px #9494941A, 5px 14px 14px 0px #94949417, 11px 30px 19px 0px #9494940D, 20px 54px 23px 0px #94949403, 31px 84px 25px 0px #94949400

    .card
      width: 100%
      gap: 0px
      border-radius: 16px
      opacity: 0px
      background: #FCF3FF
      padding: 21px

      .header
        display: flex
        align-items: center
        justify-content: space-between
        gap: 20px
        margin-bottom: 18px

        .portrait
          display: flex
          align-items: center
          gap: 12px

          &__icon
            width: 40px
            height: 40px
            background: #E4E4E4
            border-radius: 400px
            overflow: hidden
            object-fit: cover

            img
              height: 100%

          &__text
            font-size: 16px
            font-weight: 700
            line-height: 22.4px
            color: #000000

        .stars
          display: flex
          align-items: center
          gap: 4px

          &__icon
            width: 20px
            height: 20px

      .content
        width: 100%

        &__text
          font-size: 15px
          font-weight: 400
          line-height: 21px
          text-align: left
          color: #1B2A3F

          &:lang(ar)
            text-align: right

  .review-wrapper
    display: flex
    flex-direction: column
    gap: 16px
    flex-wrap: wrap
    justify-content: center

    @media screen and (min-width: $lg)
      max-width: 1093px
      flex-direction: row
      gap: 32px
</style>
